const e = (t) => ({
  banner: {
    width: "100%",
    position: "relative",
    textAlign: "center"
  },
  expandBtn: {
    width: 40,
    padding: 0,
    minWidth: "auto",
    height: 5,
    backgroundColor: t.palette.common.grey50,
    borderRadius: 100,
    margin: "0 auto",
    cursor: "pointer",
    zIndex: t.zIndex.zIndex10,
    "&:hover, &:active": {
      backgroundColor: t.palette.common.grey50
    }
  }
}), o = e;
export {
  o as default
};
